import { ReactElement } from "react";
import BaseModal from "./BaseModal";

export interface PostClusteringModalProps {
  open: boolean;
  onClose: () => void;
  onStepSelect: (stepId: string) => void;
}

const PostClusteringModal = ({
  open,
  onClose,
  onStepSelect,
}: PostClusteringModalProps): ReactElement => {
  const handleStepClick = (stepId: string) => {
    onStepSelect(stepId);
    onClose();
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Choose Next Analysis Step"
      maxWidth="md"
    >
      <div className="p-6">
        <p className="text-gray-600 mb-6">
          Clustering is complete! You can now choose from these independent
          analysis steps:
        </p>

        <div className="space-y-4">
          <div
            className="p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
            onClick={() => handleStepClick("cell-type-annotation")}
          >
            <h3 className="font-semibold text-lg">Cell Type Annotation</h3>
            <p className="text-gray-600">
              Annotate cell types using reference data
            </p>
          </div>

          <div
            className="p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
            onClick={() => handleStepClick("marker-gene-set")}
          >
            <h3 className="font-semibold text-lg">Cell Type Identification</h3>
            <p className="text-gray-600">
              Explore known marker genes across clusters
            </p>
          </div>

          <div
            className="p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
            onClick={() => handleStepClick("de-genes-markers")}
          >
            <h3 className="font-semibold text-lg">Cell Type Markers &amp; Biomarker Discovery</h3>
            <p className="text-gray-600">Find differentially expressed genes</p>
          </div>
        </div>

        <div className="mt-6 text-sm text-gray-500">
          <p>
            💡 <strong>Tip:</strong> These steps are independent and can be done
            in any order. You can also access them directly from the workflow
            sidebar.
          </p>
        </div>
      </div>
    </BaseModal>
  );
};

export default PostClusteringModal;
